import emitter from './emitter'
import { DWT_WEBTWAIN_ID, DWT_PRODUCT_KEY, DWT_RESOURCES_PATH } from './constants'
import { handleBufferChange } from './store/handlers'
import type { BufferChangeInfo, WebTwain } from './types'
import Dynamsoft from 'dwt'
import { setDwo, useDwtStore } from './store'

const dynamsoftInit = async () => {
    if (!DWT_PRODUCT_KEY) {
        throw new Error('Missing Dynamsoft Product Key')
    }

    if (!DWT_RESOURCES_PATH) {
        throw new Error('Missing DWT Resources Path')
    }

    const priorDwo = useDwtStore.getState().dwo
    if (priorDwo) {
        console.debug('dynamsoftInit priorDwo', priorDwo)
        return priorDwo
    }

    const dwo = await new Promise<WebTwain>((resolve) => {
        Dynamsoft.DWT.RegisterEvent('OnWebTwainReady', (x) => {
            // DWT types dont have undefined as a possible return type
            const dwo = Dynamsoft.DWT.GetWebTwain() as WebTwain | undefined

            if (!dwo) {
                throw new Error('Missing Dynamsoft WebTwain Object')
            }

            emitter.on('OnBufferChanged', (bufferChangeInfo: BufferChangeInfo) => {
                void handleBufferChange(bufferChangeInfo)
            })

            dwo.RegisterEvent('OnBufferChanged', (bufferChangeInfo: BufferChangeInfo) => {
                console.debug('DWOEvent OnBufferChanged', bufferChangeInfo)
                emitter.emit('OnBufferChanged', bufferChangeInfo)
            })

            // https://www.dynamsoft.com/web-twain/docs/indepth/features/barcode.html
            // @ts-expect-error DWT doesn't understand string settings
            dwo.Addon.BarcodeReader.updateRuntimeSettings('speed').then((preSettings) => {
                console.log('dynamsoftInit barcode initalizing', preSettings)
                return dwo.Addon.BarcodeReader.updateRuntimeSettings({
                    ...preSettings,
                    expectedBarcodesCount: 1,
                }).then((settings) => {
                    console.log('dynamsoftInit barcode initalized', settings)
                })
            })

            setDwo(dwo)
            resolve(dwo)
        })

        Dynamsoft.DWT.ProductKey = DWT_PRODUCT_KEY
        Dynamsoft.DWT.ResourcesPath = DWT_RESOURCES_PATH
        // _ts-expect-error Not in types, but helpful for debugging
        // Dynamsoft.DWT.Debug = true
        Dynamsoft.DWT.Containers = [{ ContainerId: DWT_WEBTWAIN_ID, WebTwainId: 'dwtObjectId', Width: 0, Height: 0 }]
        Dynamsoft.DWT.Load()
    })

    return dwo
}

export const getDWO = () => {
    const dwo = useDwtStore.getState().dwo
    if (dwo) {
        return Promise.resolve(dwo)
    }
    // If store isn't set, intialize and resolve when ready
    return new Promise<WebTwain>((resolve) => {
        const interval = setInterval(() => {
            const dwo = useDwtStore.getState().dwo
            if (dwo) {
                clearInterval(interval)
                resolve(dwo)
            }
        }, 500)

        dynamsoftInit()
    })
}
